export default "__VITE_ASSET__Wsj2kGeS__"